import { Action } from "./action";

export class Actu {
    id_actu: string;
    texte: string = '';
    actions_a_faire: Action[] = [];

  constructor() {
  }
}


// WEBPACK FOOTER //
// ./src/app/models/actu.ts